import React, { useState, useEffect } from "react";
import { Chart, registerables } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import {
  getCorePermitApprovedData,
  getEquipmentBreakdownCount,
} from "../Utilities/URLCONSTANTS";
import axios from "axios";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
Chart.register(...registerables);

const CorePermitApproved = () => {
  // const [requestedCount, setRequestedCount] = useState([]);
  const [RequestDelvLabels, setRequestDelvLabels] = useState([]);
  const [selectedValue, setSelectedValue] = useState("All");
  const [hoveredPercentage, setHoveredPercentage] = useState(null);
  const [breakCount, setBreakCount] = useState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [requestedCount, setRequestedCount] = useState([]);
  const fetchData = async (type) => {
    const formattedStartDate = startDate ? formatDate(startDate) : null;
    const formattedEndDate = endDate ? formatDate(endDate) : null;
    const corepermitApi = getCorePermitApprovedData;
    const headers = await GetApiHeaders();
    const postData = {
      type: (startDate && endDate) ? "" : selectedValue,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
    try {
      const response = await axios.post(corepermitApi, postData, { headers });
      console.log("check the response", response);
      setRequestedCount(response.data.datasets);
      setRequestDelvLabels(response.data.labels);
    } catch (error) {
      console.log("RequestCount", error);
    }
  };




  const fetchBreakCount = async () => {
    const apiFetch = getEquipmentBreakdownCount;
    const headers = await GetApiHeaders();
    try {
      const response = await axios.get(apiFetch, { headers });
      setBreakCount(response.data.response.datasets[0].data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchBreakCount();
    const shouldFetchData = selectedValue === "DTD" && startDate && endDate;
    if (shouldFetchData || selectedValue !== "DTD") {
      fetchData(selectedValue, startDate, endDate);
    }
  }, [startDate, endDate, selectedValue]);

  const data = {
    labels: RequestDelvLabels,
    datasets: [requestedCount],
  };
  console.log(data, "get");
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        align: "start",
        labels: {
          boxWidth: 10,
          padding: 10,
        },
      },
      title: {
        display: true,
        text: " ",
        align: "start",
      },
      datalabels: {
        color: '#000',
        font: {
          size: 12,
          weight: 'bold',
        },
        formatter: (value, context) => {
          return value && value !== 0 ? value : null;
        },
        anchor: 'end',
        align: 'start',
      },
    },
  };


  const handleSelect = (e) => {
    setSelectedValue(e.target.value);
    setStartDate(null);
    setEndDate(null);
  };
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }


  // added for select custom styles
  const customSelectStyles = {
    option: (provided, state) => ({
      ...provided,
      fontFamily: 'var(--bs-font-secondary)',
      fontWeight: 'normal', // <-- Removes bold styling from options
      fontSize: '12px',
      // Custom background color based on state
      backgroundColor: state.isSelected
        ? 'var(--theme-bg-primary-color)' // Selected background color
        : state.isFocused
          ? 'var(--theme-input-focus-color)' // Hover/Focus background color
          : '#ffffff', // Default background color

      // Custom text color based on state
      color: state.isSelected
        ? '#ffffff' // Selected text color
        : state.isFocused
          ? '#333333' // Hover/Focus text color
          : '#333333', // Default text color

      // Keeps the click/active state looking clean
      ':active': {
        ...provided[':active'],
        backgroundColor: 'var(--theme-bg-primary-color)',
        color: '#ffffff',
        fontSize: '12px',
        fontWeight: 'bold',
      },
    }),
    // 2. Customize the input border focus color
    control: (provided, state) => ({
      ...provided,
      // Changes the border color when focused vs default state
      borderColor: state.isFocused ? 'var(--theme-input-focus-color)' : provided.borderColor,

      // Removes the default blue glow and replaces it (or set to 'none')
      boxShadow: state.isFocused ? '0 0 0 1px var(--theme-input-focus-color)' : provided.boxShadow,

      // Prevents the border from changing back to blue on hover while focused
      '&:hover': {
        borderColor: state.isFocused ? 'var(--theme-input-focus-color)' : provided.borderColor,
        fontSize: '12px',
        fontWeight: 'bold',
      }
    }),
    // 3. Unbold the placeholder text specifically
    placeholder: (provided) => ({
      ...provided,
      fontFamily: 'var(--bs-font-secondary)',
      fontWeight: 'normal',
      fontSize: '12px',
    }),

    // 4. Unbold the selected value text once an option is picked
    singleValue: (provided) => ({
      ...provided,
      fontFamily: 'var(--bs-font-secondary)',
      fontWeight: 'normal',
      fontSize: '12px',
    }),
  };

  const requestTimeframes = [
    { value: "All", label: "ALL" },
    { value: "WTD", label: "Current Week" },
    { value: "MTD", label: "Current Month" },
    { value: "YTD", label: "Yearly" },
    { value: "DTD", label: "Custom selection" }
  ];


  return (
    <>
      <div className="card p-4">
        <label className="chartname">Core Permit Approved</label>
        <div className="d-flex  " id="filtersInputs">

          <Select
            className="basic-single w-25"
            classNamePrefix="select"
            options={requestTimeframes}
            value={requestTimeframes.find((opt) => opt.value === selectedValue)}

            // Adapt the arguments here:
            onChange={(selectedOption) => {
              handleSelect({
                target: {
                  name: "timeframe", // Make sure this matches your state field name
                  value: selectedOption ? selectedOption.value : "" // Pass the value your state needs
                }
              });
            }}
            placeholder="Select "
            // onChange={handleSelect}
            styles={customSelectStyles} //  Your configuration will now work perfectly here!
          />
        </div>
        {selectedValue === "DTD" && (
          <div className="d-flex">
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              placeholderText="Start Date"
              className="form-control  custom-datepicker"
            />
            <DatePicker
              style={{ marginLeft: "130px  " }}
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              placeholderText="End Date"
              className="form-control  custom-date"
            />
          </div>
        )}
        <div
          className="chart-container"
          style={{
            position: "relative",
            height: "260px",
            marginLeft: "auto",
            marginTop: "-130px",
          }}
        >
          <Doughnut data={data} options={options} />

        </div>
        <hr />
        <div className="d-flex">
          <span style={{ marginTop: "-10px" }} className="chartname">
            Equipment Breakdown Dectected{" "}
          </span>{" "}
          <span style={{ marginLeft: 100, fontSize: 22, fontWeight: 700 }}>
            {breakCount}
          </span>
        </div>
        <div
          style={{
            color: "gray",
            marginTop: "-10px",
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          {" "}
          (As on Date)
        </div>
      </div>
    </>
  );
};

export default CorePermitApproved;
